import React, { useState } from 'react';
import { 
  Paper, 
  Box, 
  Button, 
  Typography, 
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
  Alert
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import axios from 'axios';
import FourPillarsResult from './FourPillarsResult';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const FourPillarsForm = ({ onSubmit }) => {
  const [birthdate, setBirthdate] = useState(dayjs());
  const [birthHour, setBirthHour] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const hours = Array.from({ length: 24 }, (_, i) => i);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!birthdate || birthHour === '') {
      setError('生年月日と時間を入力してください。');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/api/calculate`, {
        year: birthdate.year(),
        month: birthdate.month() + 1,
        day: birthdate.date(),
        hour: parseInt(birthHour)
      });

      const result = {
        ...response.data.result,
        inputData: {
          year: birthdate.year(),
          month: birthdate.month() + 1,
          day: birthdate.date(),
          hour: parseInt(birthHour)
        }
      };

      onSubmit(result); // App に渡す
    } catch (err) {
      console.error('Error fetching results:', err);
      setError('占い結果を取得できませんでした。後でもう一度お試しください。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 3, width: '100%', maxWidth: 600, mb: 4 }}>
      <Typography variant="h5" component="h2" gutterBottom>
        生年月日と時間を入力
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        あなたの四柱推命を計算するために、正確な生年月日と生まれた時間を選択してください。
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="生年月日"
            value={birthdate}
            onChange={(newDate) => setBirthdate(newDate)}
            sx={{ width: '100%', mb: 3 }}
          />
        </LocalizationProvider>

        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel id="birth-hour-label">生まれた時間</InputLabel>
          <Select
            labelId="birth-hour-label"
            value={birthHour}
            label="生まれた時間"
            onChange={(e) => setBirthHour(e.target.value)}
          >
            {hours.map((hour) => (
              <MenuItem key={hour} value={hour}>
                {hour.toString().padStart(2, '0')}:00 - {hour === 23 ? '00' : (hour + 1).toString().padStart(2, '0')}:00
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={loading}
          sx={{ mt: 2 }}
        >
          {loading ? <CircularProgress size={24} /> : '占いを見る'}
        </Button>
      </Box>
    </Paper>
  );
};

export default FourPillarsForm;

